var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":_vm.name,"label":_vm.label,"label-for":_vm.name}},[_c('b-row',[_c('b-col',[_c('v-select',{attrs:{"multiple":"","value":_vm.value,"options":_vm.optionList},on:{"input":_vm.updateValue}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }